import Controller from '@ember/controller';
import { sort } from '@ember/object/computed';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';
import { showModal } from 'sh-www/utils/modal-controls';
import { SH_PAYMENT } from "sh-www/models/sh-payment";
import { BILLABLE_RECORD } from "sh-www/models/billable-record";

const CLASS_NAME = 'SH-c-sh-invoice-view';

class AdminAccountingPayoutPayment extends Controller {
  /**
   * Register Services
   */
  @service('commands/application-commands') applicationCommandService;
  @service('state-managers/application') applicationStateManager;
  @service constants;
  @service('states/routes/admin/accounting/payout/sh-payment') state;
  @service('state-managers/routes/admin/accounting/payout/sh-payment') stateManager;

  newLineItem = {
    description: '',
    amount: '',
    type: 'adjustment'
  }
  downloadLoading = false;
  sendLoading = false;
  releaseLoading = false;

  _shPaymentActionsSort = ['createdAt:asc'];

  @sort('state.shPayment.actions', '_shPaymentActionsSort')
  _shPaymentActions;

  get className() {
    return CLASS_NAME;
  }

  /**
   * @type {String}     The css class for the payment status
   */
  @computed('state.shPayment.paymentStatusText')
  get _paymentStatusTextClass() {
    switch (this.state.shPayment.paymentStatusText) {
      case SH_PAYMENT.STATUS.PAID:
        return 'lsg-green';
      case SH_PAYMENT.STATUS.ERROR:
        return 'lsg-red';
      case SH_PAYMENT.STATUS.DUE:
        return 'lsg-yellow';
    }

    return 'lsg-dark-gray';
  }

  @computed('state.shPayment.agreement')
  get agreementText() {
    switch (this.state.shPayment.agreement) {
      case BILLABLE_RECORD.AGREEMENT.SELLER_APPROVED:
        return 'Seller Agreed';
      case BILLABLE_RECORD.AGREEMENT.BUYER_APPROVED:
        return 'Buyer Agreed';
      case BILLABLE_RECORD.AGREEMENT.AGREED:
        return 'Both Agreed';
      default:
        return 'Unknown';
    }
  }

  @computed('state.shPayment.agreement')
  get agreementTextClass() {
    if (this.state.shPayment.agreement === BILLABLE_RECORD.AGREEMENT.AGREED) {
      return 'lsg-green';
    }

    return 'lsg-yellow';
  }

  @computed('state.shPayment.approved')
  get _approvedText() {
    if (this.state.shPayment.approved) {
      return 'Approved';
    }

    return 'Un-approved';
  }

  @computed('state.shPayment.approved')
  get _approvedTextClass() {
    if (!this.state.shPayment.approved) {
      return 'lsg-yellow';
    }

    return 'lsg-green';
  }

  /**
   *
   */
  @action
  onShPaymentTransactionEdited() {
    this.stateManager.shPaymentTransactionEdited();
  }

  /**
   * @param {ShPaymentTransaction} shPaymentTransaction
   */
  @action
  onTransactionDeleted(shPaymentTransaction) {
    showModal(this, 'confirmation', {
      titleText: 'Delete Transaction',
      bodyText: 'Are you sure you want to delete this transaction?',
      actionButtonText: 'Okay',
      isShowCancelButton: true,
      confirmAction: () => {
        this.stateManager.deleteTransaction(shPaymentTransaction).then(() => {
          this.applicationStateManager.addToast('Transaction Deleted');
        }).catch((e) => {
          handleErrorResponseWithModal(
            this,
            e,
            'There was an error deleting the transaction. Please refresh and try again.',
            'onTransactionDeleted -- error marking transaction deleted for transaction id : ' + shPaymentTransaction.id,
          );
        });
      },
    });
  }

  /**
   *
   */
  @action
  onEditFeesClicked() {
    const modalModel = {
      relatedModel: this.state.shPayment,
      showBuyerFees: false,
      showSellerFees: true,
      onFeesUpdated: (madeFMS) => {
        this.stateManager.feesUpdated(madeFMS);
      }
    };

    showModal(this, 'projects/edit-project-fees-modal', modalModel);
  }

  @action
  onReconcileBilling() {
    showModal(this, 'confirmation', {
      titleText: 'Reconcile Billing',
      bodyText: "This will re-calculate the application's billing, and set payout, process payment, send emails, etc. if appropriate.",
      actionButtonText: 'Okay',
      isShowCancelButton: true,
      confirmAction: () => {
        this.applicationCommandService.reconcileBilling(this.state.shPayment.application)
          .then(() => {
            this.applicationStateManager.addToast('Billing reconciled');
          })
          .catch((e) => {
            handleErrorResponseWithModal(
              this,
              e,
              'There was an error reconciling billing. Please contact engineering for support.',
              `reconcileBilling -- Failing reconciling app id: ${this.state.shPayment.application.id}`,
            );
          });
      },
    });
  }
}

export default AdminAccountingPayoutPayment;
